import { EntityState } from '@reduxjs/toolkit';
import { DevBoxAddOns } from '../../models/add-ons';
import { Entity } from '../../models/common';
import { createInitializer } from '../../utilities/initializer';
import { statusAdapter } from '../adapters/common/status-adapter';
import { devBoxAddOnsAdapter } from '../adapters/dev-box-add-ons-adapters';
import { IndexedStatusStore } from './indexed-status-store';

type IndexedStatusName = 'listDevBoxAddOns';

export interface DevBoxAddOnsDataStore {
    devBoxAddOns: EntityState<Entity<DevBoxAddOns[]>>;
}
export const DevBoxAddOnsDataStore = createInitializer<DevBoxAddOnsDataStore>({
    devBoxAddOns: devBoxAddOnsAdapter.getInitialState(),
});

export type AddOnsStatusStore = IndexedStatusStore<IndexedStatusName>;

export const AddOnsStatusStore = createInitializer<AddOnsStatusStore>({
    listDevBoxAddOns: statusAdapter.getInitialState(),
});

export interface AddOnsStore {
    status: AddOnsStatusStore;
    data: DevBoxAddOnsDataStore;
}

export const AddOnsStore = createInitializer<AddOnsStore>({
    status: AddOnsStatusStore(),
    data: DevBoxAddOnsDataStore(),
});
